// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import { ToastPlugin } from 'bootstrap-vue';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import ActivateService from './account/activate/activate.service';
import RegisterService from './account/register/register.service';
import UserManagementService from './admin/user-management/user-management.service';
import LoginService from './account/login.service';
import AccountService from './account/account.service';
import AlertService from './shared/alert/alert.service';
import idleService from './shared/idle-service';
import axios from 'axios';

import '../content/scss/global.scss';
import '../content/scss/vendor.scss';
/* tslint:disable */

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.directive('click-outside', {
  inserted: (el, binding, vnode) => {
    // assign event to the element
    el.clickOutsideEvent = function (event) {
      // here we check if the click event is outside the element and it's children
      if (!(el == event.target || el.contains(event.target))) {
        // if clicked outside, call the provided method
        vnode.context[binding.expression](event);
      }
    };
    // register click and touch events
    document.body.addEventListener('click', el.clickOutsideEvent);
    document.body.addEventListener('touchstart', el.clickOutsideEvent);
  },
  unbind: function (el) {
    // unregister click and touch events before the element is unmounted
    document.body.removeEventListener('click', el.clickOutsideEvent);
    document.body.removeEventListener('touchstart', el.clickOutsideEvent);
  },
  stopProp(event) {
    event.stopPropagation();
  },
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
const store = config.initVueXStore(Vue);

const loginService = new LoginService();
const accountService = new AccountService(store, (<any>Vue).cookie, router);

function clearLocalSession() {
  idleService.stopIdleWatcher();

  localStorage.removeItem('jhi-authenticationToken');
  sessionStorage.removeItem('jhi-authenticationToken');
  localStorage.removeItem('sasai-last-activity');
  sessionStorage.removeItem('requested-url');

  // Elimina el token que Axios pudiera tener en memoria.
  delete axios.defaults.headers.common.Authorization;

  // Limpia el estado de autenticación de Vuex.
  store.commit('logout');
}

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    return next('/not-found');
  }

  const protectedRecords = to.matched.filter(record => {
    const roles = record.meta && record.meta.authorities;

    return Array.isArray(roles) && roles.length > 0;
  });

  // Las pantallas públicas pueden abrirse sin validar permisos.
  if (protectedRecords.length === 0) {
    return next();
  }

  const hasIdleSession = () => {
    const lastActivity = Number(localStorage.getItem('sasai-last-activity'));

    return Number.isFinite(lastActivity) && lastActivity > 0;
  };

  const idleSessionEnded = () => !hasIdleSession() || idleService.isIdleExpired();

  if (idleSessionEnded()) {
    clearLocalSession();

    return next({ name: 'Home', replace: true });
  }

  try {
    for (const record of protectedRecords) {
      const allowed = await accountService.hasAnyAuthorityAndCheckAuth(record.meta.authorities);

      // El contador pudo vencer mientras esperábamos.
      if (idleSessionEnded()) {
        clearLocalSession();

        return next({ name: 'Home', replace: true });
      }

      if (!allowed) {
        return next({ name: 'Forbidden', replace: true });
      }
    }

    return next();
  } catch (error) {
    console.warn('No se pudo validar el acceso:', error);

    if (idleSessionEnded()) {
      clearLocalSession();
    }

    return next({ name: 'Home', replace: true });
  }
});
export const eventBus = new Vue();
/* tslint:disable */
const vue = new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  mounted() {
    // Esta fecha se guarda después de un login exitoso.
    const lastActivity = Number(localStorage.getItem('sasai-last-activity'));

    if (Number.isFinite(lastActivity) && lastActivity > 0) {
      idleService.startIdleWatcher(router, () => {
        // Primero limpia la sesión local.
        clearLocalSession();

        // Intenta invalidar también la sesión del servidor.
        // La redirección no espera esta respuesta.
        try {
          loginService.logout().catch(error => {
            console.warn('No se pudo cerrar la sesión en el servidor:', error);
          });
        } catch (error) {
          console.warn('Error al solicitar el cierre de sesión:', error);
        }
      });
    }
  },
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userManagementService: () => new UserManagementService(),
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    alertService: () => new AlertService(),
  },
  store,
});

setupAxiosInterceptors(
  error => {
    const response = error && error.response;
    const status = response ? response.status : error && error.status;

    const url = String((error && error.config && error.config.url) || (response && response.config && response.config.url) || '');

    // Reconoce URLs relativas y absolutas.
    const isLoginRequest = /(?:^|\/)api\/(?:authenticate|authentication)(?:[/?#]|$)/.test(url);

    if (status === 401 && !isLoginRequest) {
      clearLocalSession();

      // Solo redirige si la pantalla actual requiere autenticación.
      const requiresAuthentication = router.currentRoute.matched.some(record => {
        const roles = record.meta && record.meta.authorities;
        return Array.isArray(roles) && roles.length > 0;
      });

      if (requiresAuthentication && router.currentRoute.name !== 'Home') {
        router.replace({ name: 'Home' }).catch(navError => {
          if (navError.name !== 'NavigationDuplicated') {
            console.error('Error al regresar al inicio:', navError);
          }
        });
      }
    }

    return Promise.reject(error);
  },
  error => {
    console.error('Error del servidor o de conexión:', error);
    return Promise.reject(error);
  }
);
